import { jsx, jsxs } from "react/jsx-runtime";
import { GreedyColumn } from "./components/GreedyColumn.js";
import { Header } from "./components/Header.js";
import { TextAligner } from "./components/TextAligner.js";
import { TextPlacer } from "./components/TextPlacer.js";
function ColorGroupHeader(props) {
  const { label, children } = props;
  return /* @__PURE__ */ jsxs(Header, { children: [
    /* @__PURE__ */ jsx(GreedyColumn, { children: /* @__PURE__ */ jsx(TextPlacer, { children: /* @__PURE__ */ jsx(TextAligner, { children: label }) }) }),
    children
  ] });
}
export {
  ColorGroupHeader
};
//# sourceMappingURL=ColorGroupHeader.js.map
